import * as Yup from "yup";

export const invoiceValidationSchema = Yup.object({
  documentOwner: Yup.string().max(100, "User cannot exceed 100 characters"),
  supplier: Yup.string()
// Changes requested by UAT
    // .matches(
    //   /^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/,
    //   "Must contain at least one alphabet, cannot be numeric-only, no symbols"
    // )
    // .min(3, "Supplier must be at least 3 characters")
    .max(200, "Supplier cannot exceed 200 characters")
    // .required("Supplier is required")
    ,

  extractedPoNumber: Yup.string()
    .nullable()
    .matches(/^[A-Za-z0-9]*$/, "Alphanumeric only; no special characters")
    .max(50, "PO Number cannot exceed 50 characters"),

  documentReference: Yup.string()
    .nullable()
    .matches(/^[A-Za-z0-9-/]*$/, "Alphanumeric, dashes, and slashes only")
    .max(50, "Document Reference cannot exceed 50 characters"),

  dueDate: Yup.string()
    .nullable()
    .when("paid", {
      is: (paid: boolean) => paid === false,
      then: (schema) => schema.required("Due Date is required when not paid"),
    }),

  category: Yup.string()
    .nullable()
    .matches(/^[A-Za-z0-9 ]*$/, "No special characters allowed")
    .max(100, "Category cannot exceed 100 characters"),
  //.required("Category is required")
  productOrService: Yup.string()
    .nullable()
    .matches(/^[A-Za-z0-9 ]*$/, "Alphanumeric only; symbols not allowed")
    .max(50, "Product/Service cannot exceed 50 characters"),

  customer: Yup.string()
    .nullable()
    .when("markAsRebillable", (markAsRebillable, schema) =>
      markAsRebillable
        ? schema
            // .required("Customer is required")
            .matches(/^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/, "Must include letters")
        : schema
    ),

  markAsRebillable: Yup.string().nullable(),

  description: Yup.string()
    .nullable()
    .max(250, "Description cannot exceed 250 characters")
    .matches(/^(?!.*<script>).*$/, "HTML, JS, SQL code not allowed"),

  currency: Yup.string()
    .nullable()
    // .oneOf(currencies, "Invalid currency")
    // .length(3, "Currency must be exactly 3 letters")
    .required("Currency is required"),

  totalAmount: Yup.number()
    .nullable(),
    // .min(0.01, "Total Amount must be at least 0.01")
    // .max(9999999999.99, "Total Amount exceeds maximum")
    // .required("Total Amount is required"),
  taxAmount: Yup.number()
    .nullable(),
    // .min(0, "Tax Amount cannot be negative")
    // .max(Yup.ref("totalAmount"), "Tax cannot exceed Total Amount"),
  netAmount: Yup.number().nullable(),
  // .min(0, "Net Amount cannot be negative"),
  //  .required("Net Amount is required"),
  // .test(
  //   "net-equals-total-tax",
  //   "Net Amount must equal TotalTax"
  //   ,
  //   function (value) {
  //     const { totalAmount, taxAmount } = this.parent;
  //     if (totalAmount != null && taxAmount != null && value != null) {
  //       return Math.abs(value - (totalAmount - taxAmount)) <= 0.01;
  //     }
  //     return true;
  //   }
  // ),

  payment: Yup.number()
    .nullable(),
    //.max(Yup.ref("totalAmount"), "Payment cannot exceed Total Amount"),

  paymentMethod: Yup.string()
    .nullable()
    .when("paid", {
      is: true,
      then: (schema) =>
        schema.required("Payment Method is required when Paid is Yes"),
    }),

  discountAmount: Yup.number()
    .nullable()
    .min(0, "Discount Amount cannot be negative"),

    supplierId: Yup.number().nullable(),
    categoryId: Yup.number().nullable(),
});
